import { MOKA_INVENTORY_API, MOKA_STOCK_TRANSFER_API } from '../../constants';

export const V1_URL = `${MOKA_INVENTORY_API}/v1/inventory`;
export const V1_TRANSFERS = `${V1_URL}/transfers`;
export const V1_EXPORT_TRANSFER = `${V1_TRANSFERS}/export`;
export const V1_ADVANCED_INVENTORY_ITEM_TRANSFER = `${MOKA_STOCK_TRANSFER_API}/v1/item-transfer`;
export const V1_ADVANCED_INVENTORY_INGREDIENT_TRANSFER = `${MOKA_STOCK_TRANSFER_API}/v1/ingredient-transfer`;
export const V2_ITEM_COGS = `${MOKA_INVENTORY_API}/v2/items`;
export const V1_INGREDIENT_COGS = `${MOKA_INVENTORY_API}/v1/ingredients`;

export const V1_ADVANCED_INVENTORY_SUBMIT_ITEM_APPROVAL = (id) =>
  `${MOKA_STOCK_TRANSFER_API}/v1/item-transfer/${id}/approve`;
export const V1_ADVANCED_INVENTORY_SUBMIT_INGREDIENT_APPROVAL = (id) =>
  `${MOKA_STOCK_TRANSFER_API}/v1/ingredient-transfer/${id}/approve`;
